/**
 * AI 프롬프트 입력 길이 제한 (locale별).
 *
 * 클라이언트 측 cost/UX 가이드 한도. UI 표시 locale(`useLocale`) 기준으로 입력을
 * hard-block 하여 토큰 cost·응답 품질을 최적화한다.
 */
export const PROMPT_MAX_LENGTH_BY_LOCALE: Record<string, number> = {
  en: 3000,
  ko: 1000,
  ja: 750,
  zh: 750,
};

export const DEFAULT_PROMPT_MAX_LENGTH = 750;

export const getPromptMaxLength = (locale: string): number => {
  const key = locale.split('-')[0].toLowerCase();
  return PROMPT_MAX_LENGTH_BY_LOCALE[key] ?? DEFAULT_PROMPT_MAX_LENGTH;
};
